/**
 * Routes of the admin feature (`docs/ADMIN.md` §2), mounted directly by
 * `src/App.tsx`.
 *
 * Unlike `session`/`household`'s flat `RouteObject[]` (spread inside a
 * single shared `<Route element={<ProtectedShell/>}>`), this feature needs
 * its own nested layout route: the guard and the shell both read `:insee`
 * from the URL, so they must sit on (or under) the route that declares that
 * param, not on a param-less wrapper shared with the militant screens.
 * `adminRouteElement` is exported ready to drop into `App.tsx`'s
 * `<Routes>`, the same way a hand-written nested `<Route>` tree would be.
 */
import { Route } from 'react-router-dom';

import { AdminLayout } from './AdminLayout';
import { RequireCommuneAdmin } from './guard';
import { CommunePage } from './pages/CommunePage';
import { EngagementsPage } from './pages/EngagementsPage';
import { InscriptionsPage } from './pages/InscriptionsPage';
import { NotesPage } from './pages/NotesPage';

/** Layout route wrapping {@link AdminLayout} in the commune-admin guard. */
function AdminProtectedShell() {
  return (
    <RequireCommuneAdmin>
      <AdminLayout />
    </RequireCommuneAdmin>
  );
}

export const adminRouteElement = (
  <Route path="/admin/:insee" element={<AdminProtectedShell />}>
    <Route index element={<CommunePage />} />
    <Route path="inscriptions" element={<InscriptionsPage />} />
    <Route path="notes" element={<NotesPage />} />
    <Route path="engagements" element={<EngagementsPage />} />
  </Route>
);
